import { http } from './config'

export default {
  listandoCidade:() => {
    return http.get('cidade.php')
  }
}